// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__39Or8","title":"ClientInsurance_title__wW3i_","itemText":"ClientInsurance_itemText__3wq3p"};